export default __webpack_public_path__ + "static/park-ranger-govt-official-248874b012a39220fa6a3a8cdb26bd4a.png";